// ABOUTME: Hook that reads the enableFavorite system-settings flag from the SettingsContext.
// ABOUTME: Favorites are opt-in: consumers hide or error their UI when this returns false.

import { SettingsContext } from '@src/modules/setting/SettingsContext';
import { useContext } from 'react';

export function useFavoritesEnabled(): boolean {
    const settings = useContext(SettingsContext);
    return !!settings.enableFavorite;
}
